export const visit = (vm, at) => {
at({ "pt-br": { "pricing-page-components": { "phone-support": { "seePhoneNumber": "Veja o n\xFAmero de telefone" } } } });
};